import { FC, InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import Svg from '../Svg';
import { CrossCircle } from '@/icons';

type InputTypes = 'text' | 'number' | 'password' | 'email';

export type FormPropTypes = {
  isValidation?: boolean;
  error?: any;
  register?: any;
  autoFocus?: boolean;
  disabled?: boolean;
  maxLength?: number;
  id?: string;
  ref?: any;
};

export interface FieldPropTypes
  extends FormPropTypes, InputHTMLAttributes<any> {
  id: string;
  type?: InputTypes;
  placeholder?: string;
  inputClassName?: string;
  labelClassName?: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
}

const TextField: FC<FieldPropTypes> = ({
  id,
  type = 'text',
  placeholder = '',
  inputClassName,
  startAdornment,
  endAdornment,
  maxLength,
  error,
  register,
  isValidation = true,
  onChange,
  ...rest
}) => {
  return (
    <div aria-label={id} className={twMerge('space-y-1', rest.className)}>
      <div className='relative'>
        {startAdornment && startAdornment}
        <input
          id={id}
          name={id}
          type={type}
          onChange={onChange}
          data-error={!!error?.message}
          placeholder={placeholder}
          {...(isValidation && register(id))}
          maxLength={maxLength}
          {...rest}
          className={twMerge(
            `w-full text-base rounded-lg border p-3 placeholder:text-gray-500/80 placeholder:text-sm`,
            error ? 'border-red-500' : 'border-black/20',
            inputClassName
          )}
        />
        {endAdornment && endAdornment}
      </div>
      {error && (
        <label
          htmlFor={id}
          className='flex items-center justify-start gap-x-1 text-left text-xs text-error'>
          {id === 'pincode' && (
            <Svg
              className='rounded-full bg-[#D21212] stroke-white p-1'
              viewBox='15 10 10 20'>
              <CrossCircle />
            </Svg>
          )}{' '}
          {error?.message}
        </label>
      )}
    </div>
  );
};

export default TextField;
